import en from './locales/en';
import nl from './locales/nl';
export var LOCALES = { en: en, nl: nl };
export var DEFAULT_LOCALE = nl;
